export default __webpack_public_path__ + "static/media/bg-swirls.5a761557.svg";